import { render, staticRenderFns } from "./GoldSchemeView.vue?vue&type=template&id=4856dcae&"
import script from "./GoldSchemeView.vue?vue&type=script&lang=js&"
export * from "./GoldSchemeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports